import { ConfigProvider } from 'antd-mobile';
import zhTW from 'antd-mobile/es/locales/zh-TW';
import App2 from 'App2';
import Board from 'pages/console/board';
import Comment from 'pages/console/cnt/comment';
import Post from 'pages/console/cnt/post';
import Video from 'pages/console/cnt/video';
import VideoAlbum from 'pages/console/cnt/video-album';
import VideoTag from 'pages/console/cnt/video-tag';
import VideoTagType from 'pages/console/cnt/video-tag-type';
import VideoType from 'pages/console/cnt/video-type';
import Login2 from 'pages/console/login2';
import Anno from 'pages/console/ope/anno';
import Carousel from 'pages/console/ope/carousel';
import CarouselType from 'pages/console/ope/carousel-type';
import Media from 'pages/console/ope/media';
import Webset from 'pages/console/ope/webset';
import Menu from 'pages/console/sys/menu';
import Role from 'pages/console/sys/role';
import User from 'pages/console/sys/user';
import Clock from 'pages/console/usr/clock';
import ClockList from 'pages/console/usr/clock-list';
import Feedback from 'pages/console/usr/feedback';
import UserDetail from 'pages/console/usr/user-detail';
import UserGroup from 'pages/console/usr/user-group';
import VideoList from 'pages/console/usr/video-list';
import Detail from 'pages/webapp/detail';
import FuncPlayer from 'pages/webapp/func/player';
import Login from 'pages/webapp/login';
import Ops from 'pages/webapp/ops';
import PageOne from 'pages/webapp/page_one';
import Home from 'pages/webapp/page_one/home';
import Mine from 'pages/webapp/page_one/mine';
import Osusume from 'pages/webapp/page_one/osusume';
import Square from 'pages/webapp/page_one/square';
import Player from 'pages/webapp/player';
import ReaderArticle from 'pages/webapp/reader-article';
import ReaderImage from 'pages/webapp/reader-image';
import ReaderManga from 'pages/webapp/reader-manga';
import ReaderPicture from 'pages/webapp/reader-picture';
import Search from 'pages/webapp/search';
import Sesame from 'pages/webapp/sesame';
import Success from 'pages/webapp/success';
import Term from 'pages/webapp/term';
import Test from 'pages/webapp/test';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import App from './App';
import store from './app/store';
import './i18n/config';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ConfigProvider locale={zhTW}>
    <Provider store={store}>
      {/* StrictMode可能和react-beautiful-dnd冲突 */}
      {/* <React.StrictMode> */}
        <BrowserRouter>
          <Routes>
            {/* 根路由 */}
            <Route
              path="/func/player"
              element={<FuncPlayer />}
            />
            <Route
              path="/ops"
              element={<Ops />}
            />
            <Route
              path="/success"
              element={<Success />}
            />
            <Route
              path="/"
              element={<App />}
            >
              {/* 定制默认子路由，重定向到 /one/home */}
              {/* <Route index path="/" element={<Sesame />} /> */}
              {/* 默认子路由，重定向到 /one/home */}
              {/* <Route index path="/" element={<Navigate to={"/one/home"} />} /> */}
              {/* 其他根路径下的路由 */}
              <Route
                path="test"
                element={<Test />}
              />

              {/* PageOne 路由 */}
              <Route
                path="one"
                element={<PageOne />}
              >
                {/* PageOne 下的默认子路由 */}
                <Route
                  index
                  element={<Osusume />}
                />
                {/* PageOne 下的其他子路由 */}
                <Route
                  path="osusume"
                  element={<Osusume />}
                />
                <Route
                  path="home"
                  element={<Home />}
                />
                <Route
                  path="square"
                  element={<Square />}
                />
                <Route
                  path="mine"
                  element={<Mine />}
                />
              </Route>
              {/* <Route path="/" element={<MainPage/>}>
          </Route> */}
              <Route
                path="search"
                element={<Search />}
              />
              <Route
                path="term"
                element={<Term />}
              />
              <Route
                path="sesame"
                element={<Sesame />}
              />
              <Route
                path="detail"
                element={<Detail />}
              />
              <Route
                path="reader-manga"
                element={<ReaderManga />}
              />
              <Route
                path="reader-image"
                element={<ReaderImage />}
              />
              <Route
                path="reader-picture"
                element={<ReaderPicture />}
              />
              <Route
                path="reader-article"
                element={<ReaderArticle />}
              />
              <Route
                path="player"
                element={<Player />}
              />
              <Route
                path="login"
                element={<Login />}
              />
              {/* <Route path="order" element={<Order />} /> */}
              {/* <Route path="home" element={<Home />} />
          <Route path="cate" element={<Cate />} />
          <Route path="tag" element={<Tag />} />
          <Route path="album" element={<Album />} />
          <Route path="cate2" element={<Cate2 />} />
          <Route path="list" element={<List />} />
          <Route path="play" element={<Play />} />

          <Route path="user" element={<User />} />
          <Route path="login" element={<Login />} />

          <Route path="error" element={<Error />} />
          <Route path="search" element={<Search />} />
          <Route path="order" element={<Order />} />

          <Route path="*" element={<Error />} /> */}
            </Route>
            <Route
              path="/console"
              element={<App2 />}
            >
              <Route
                element={<Board />}
                index
              />
              <Route
                path="board"
                element={<Board />}
              />
              <Route
                path="login"
                element={<Login2 />}
              />
              <Route path="cnt">
                <Route
                  element={<Video />}
                  index
                />
                <Route
                  path="post"
                  element={<Post />}
                />
                <Route
                  path="video"
                  element={<Video />}
                />
                <Route
                  path="video-type"
                  element={<VideoType />}
                />
                <Route
                  path="video-album"
                  element={<VideoAlbum />}
                />
                <Route
                  path="video-tag"
                  element={<VideoTag />}
                />
                <Route
                  path="video-tag-type"
                  element={<VideoTagType />}
                />
                <Route
                  path="comment"
                  element={<Comment />}
                />
              </Route>
              <Route path="ope">
                <Route
                  element={<Webset />}
                  index
                />
                <Route
                  path="webset"
                  element={<Webset />}
                />
                <Route
                  path="media"
                  element={<Media />}
                />
                <Route
                  path="carousel"
                  element={<Carousel />}
                />
                <Route
                  path="carousel-type"
                  element={<CarouselType />}
                />
                <Route
                  path="anno"
                  element={<Anno />}
                />
              </Route>
              <Route path="usr">
                <Route
                  element={<UserGroup />}
                  index
                />
                <Route
                  path="user-group"
                  element={<UserGroup />}
                />
                <Route
                  path="user-detail"
                  element={<UserDetail />}
                />
                <Route
                  path="video-list"
                  element={<VideoList />}
                />
                <Route
                  path="clock"
                  element={<Clock />}
                />
                <Route
                  path="clock-list"
                  element={<ClockList />}
                />
                <Route
                  path="feedback"
                  element={<Feedback />}
                />
              </Route>
              <Route path="sys">
                <Route
                  element={<User />}
                  index
                />
                <Route
                  path="user"
                  element={<User />}
                />
                <Route
                  path="role"
                  element={<Role />}
                />
                <Route
                  path="menu"
                  element={<Menu />}
                />
              </Route>
            </Route>
            {/* <Route path="/console" element={<App2 />}>
          <Route element={<Board />} index />
          <Route path="board" element={<Board />} />
          <Route path="login" element={<Login2 />} />
          <Route path="cnt">
            <Route element={<Video />} index />
            <Route path="video" element={<Video />} />
            <Route path="video-type" element={<VideoType />} />
            <Route path="video-album" element={<VideoAlbum />} />
            <Route path="video-tag" element={<VideoTag />} />
            <Route path="video-tag-type" element={<VideoTagType />} />
            <Route path="comment" element={<Comment />} />
          </Route>
          <Route path="ope">
            <Route element={<Webset />} index />
            <Route path="webset" element={<Webset />} />
            <Route path="media" element={<Media />} />
            <Route path="carousel" element={<Carousel />} />
            <Route path="carousel-type" element={<CarouselType />} />
            <Route path="anno" element={<Anno />} />
          </Route>
          <Route path="usr">
            <Route element={<UserGroup />} index />
            <Route path="user-group" element={<UserGroup />} />
            <Route path="user-detail" element={<UserDetail />} />
            <Route path="video-list" element={<VideoList />} />
            <Route path="clock" element={<Clock />} />
            <Route path="clock-list" element={<ClockList />} />
          </Route>
          <Route path="sys">
            <Route element={<User />} index />
            <Route path="user" element={<User />} />
            <Route path="role" element={<Role />} />
            <Route path="menu" element={<Menu />} />
          </Route>
        </Route> */}
          </Routes>
        </BrowserRouter>
      {/* </React.StrictMode> */}
    </Provider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
